import React from 'react';
import { Grid, makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import clsx from 'clsx';
import SweetAlert from '../Alerts/SweetAlert';
import AttachmentInput from './AttachmentInput';

const AttachmentListSection = ({
  title,
  fileInputId,
  files,
  setFiles,
  totalSize,
  setTotalSize,
  attachmentSetupList,
  maxMBFileSize,
  validFileExtensions
}) => {
  const classes = useStyles();
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));
  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.title}>{title}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        className={clsx(
          classes.inputContainerItem,
          classes.sweetAlertContainer
        )}
      >
        <SweetAlert
          id="Pqr_Contact_alert"
          type="info"
          noIcon={isMobileSize}
          message={
            <>
              Archivos permitidos: {validFileExtensions.map(ext => ` .${ext}`)}.
              <br />
              Tamaño total de los archivos: {totalSize} MB/{maxMBFileSize} MB
            </>
          }
          classes={{
            root: classes.sweetAlert,
            message: classes.sweetAlertText
          }}
        />
      </Grid>
      {attachmentSetupList.map((attachment, index) => (
        <Grid item xs={12} key={index} className={classes.inputContainerItem}>
          <AttachmentInput
            {...attachment}
            index={index}
            fileInputId={fileInputId}
            files={files}
            totalSize={totalSize}
            setFiles={setFiles}
            setTotalSize={setTotalSize}
          />
        </Grid>
      ))}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 18,
    fontWeight: 700
  },
  inputContainerItem: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing()
  },
  sweetAlertContainer: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(2)
    }
  },
  sweetAlert: {
    [theme.breakpoints.up('sm')]: {
      height: 58
    }
  },
  sweetAlertText: {
    fontSize: 14
  }
}));

export default AttachmentListSection;
